import qs from 'qs'

import { routeNameInKor } from '@/router'
import WebviewService from '@/service/webview.service'

const navigationUtils = {
  getLastRouteNameInKor(pathname?: string) {
    if (!pathname) return ''
    const lastPath = pathname.split('/').pop()
    return `${lastPath ? routeNameInKor(lastPath) : ''} `
  },
  getPathname(pathname: string) {
    const splitted = pathname.split('?')
    return splitted[0]
  },
  reload() {
    if (WebviewService.isAppAndroid && WebviewService.device && WebviewService.version) {
      const url = new URL(window.location.href)
      url.searchParams.set('device', WebviewService.device)
      url.searchParams.set('version', WebviewService.version.toString())

      window.history.replaceState(null, '', url.toString())
    }

    return window.location.reload()
  },
  addQueryParamsToPathname(pathname: string, newSearch: string) {
    const oldSearch = this.getSearch(pathname)
    const newQueryParams = this.upsertQueryParams(oldSearch, newSearch)
    return `${this.getPathname(pathname)}?${newQueryParams}`
  },
  upsertQueryParams(oldSearch: string, newSearch: string, opt = { addQueryPrefix: true }) {
    if (newSearch === '') return oldSearch
    if (oldSearch === '') return newSearch

    const newQueryParams = qs.parse(newSearch, { ignoreQueryPrefix: true })
    const oldQueryParams = qs.parse(oldSearch, { ignoreQueryPrefix: true })
    return qs.stringify(
      { ...oldQueryParams, ...newQueryParams },
      { addQueryPrefix: opt.addQueryPrefix },
    )
  },
  getSearch(pathname: string) {
    const splitted = pathname.split('?')
    if (splitted.length > 1) {
      return splitted[1]
    }
    return ''
  },
  isAbsoluteUrl(url: string): boolean {
    try {
      new URL(url)
      return true
    } catch (error) {
      return false
    }
  },
}

export default navigationUtils
